<template>
  <section class="cs-container-wrapper">
    <!-- Header Info -->
    <div class="row">
      <div class="col-sm-12">
        <div class="d-flex justify-space-between">
          <div class="d-flex align-center justify-center">
            <h4 class="mt-1 mb-2 text-left header-store">
              <fai :icon="['fas', 'home']"/>
              {{
                selectedStore && selectedStore.store && selectedStore.store.name
                  ? selectedStore.store.name.toLowerCase()
                  : "no store name"
              }}
            </h4>
          </div>
          <div class="d-flex align-center justify-center">
            <span v-if="selectedStore && selectedStore.updated_at" class="">
              last updated: {{ formatDate(selectedStore.updated_at).toLowerCase() }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Three Info Boxes -->
    <div v-if="selectedStore.length != 0" class="row">

      <!-- Box One: NPS -->
      <div class="col-sm-4">
        <div class="box box-wrapper">
          <div class="box-body text-center">
            <h3 class="text-center mt-0 mb-2">nps score</h3>
            <!-- NPS Score Details -->
            <div class="flex-container">
              <div class="current-30-wrapper">
                <div class="score-right mx-1 mb-2">
                  <h1 class="score-current mb-0 mt-0">{{selectedStore.nps_score_current.toFixed(2)}}</h1>
                  <span class="small">current 30 day</span>
                </div>
              </div>

              <div class="extra-wrapper mx-2">
                <div class="score-left mx-1 mb-2">
                  <h3 class="score-prior mb-0 mt-0">{{selectedStore.nps_score_prior.toFixed(2)}}</h3>
                  <span class="small">previous 30 day</span>
                </div>

                <div class="score-left mx-1 mb-2">
                  <h4
                    class="percentage-change mb-0 mt-0"
                    :class="percents.over_prior.nps < 0 ? 'red':'green'"
                  >
                    <fai v-if="percents.over_prior.nps < 0" 
                         :icon="['fas', 'long-arrow-down']"
                         class='red'/>
                    <fai v-if="percents.over_prior.nps > 0" 
                         :icon="['fas', 'long-arrow-up']"
                         class='green'/>
                    {{percents.over_prior.nps}}%
                  </h4>
                  <span class="small" :class="percents.over_prior.nps < 0 ? 'red':'green'"
                    >{{ percents.over_prior.nps | directionAText }}</span
                  >
                </div>
              </div>
            </div>

            <!-- NPS Score Stats -->
            <p class="text-muted text-center mt-1">
              your current score is
              <span :class="percents.over_industry.nps < 0 ? 'red':'green'"
                ><b>{{percents.over_industry.nps}}% {{ percents.over_industry.nps | directionBText }}</b></span
              >
              the current nps score industry average of
              <b>{{selectedStore.industry_average_nps.toFixed(2)}}</b>.
            </p>
          </div>
        </div>
      </div>

      <!-- Box Two: CS -->
      <div class="col-sm-4">
        <div class="box box-wrapper">
          <div class="box-body text-center">
            <h3 class="text-center mt-0 mb-2">cs score</h3>
            <!-- CS Score Details -->
            <div class="flex-container">
              <div class="current-30-wrapper">
                <div class="score-right mx-1 mb-2">
                  <h1 class="score-current mb-0 mt-0">{{selectedStore.crs_score_current.toFixed(2)}}</h1>
                  <span class="small">current 30 day</span>
                </div>
              </div>

              <div class="extra-wrapper mx-2">
                <div class="score-left mx-1 mb-2">
                  <h3 class="score-prior mb-0 mt-0">{{selectedStore.crs_score_prior.toFixed(2)}}</h3>
                  <span class="small">previous 30 day</span>
                </div>

                <div class="score-left mx-1 mb-2">
                  <h4
                    class="percentage-change mb-0 mt-0"
                    :class="percents.over_prior.crs < 0 ? 'red':'green'"
                  >
                    <fai v-if="percents.over_prior.crs < 0" 
                         :icon="['fas', 'long-arrow-down']"
                         class='red'/>
                    <fai v-if="percents.over_prior.crs > 0" 
                         :icon="['fas', 'long-arrow-up']"
                         class='green'/>
                    {{percents.over_prior.crs}}%
                  </h4>
                  <span class="small" :class="percents.over_prior.crs < 0 ? 'red':'green'"
                    >{{ percents.over_prior.crs | directionAText }}</span
                  >
                </div>
              </div>
            </div>

            <!-- CRS Score Stats -->
            <p class=" text-muted text-center mt-1">
              your current score is
              <span :class="percents.over_industry.crs < 0 ? 'red':'green'"
                ><b>{{percents.over_industry.crs}}% {{ percents.over_industry.crs | directionBText }}</b></span
              >
              the current cs score industry average of
              <b>{{selectedStore.industry_average_crs.toFixed(2)}}</b>.
            </p>
          </div>
        </div>
      </div>

      <!-- Box Three: Product -->
      <div class="col-sm-4">
        <div class="box box-wrapper">
          <div class="box-body text-center">
            <h3 class="text-center mt-0 mb-2">product score</h3>
            <!-- Product Score Details -->
            <div class="flex-container">
              <div class="current-30-wrapper">
                <div class="score-right mx-1 mb-2">
                  <h1 class="score-current mb-0 mt-0">{{selectedStore.product_score_current.toFixed(2)}}</h1>
                  <span class="small">current 30 day</span>
                </div>
              </div>

              <div class="extra-wrapper mx-2">
                <div class="score-left mx-1 mb-2">
                  <h3 class="score-prior mb-0 mt-0">{{selectedStore.product_score_prior.toFixed(2)}}</h3>
                  <span class="small">previous 30 day</span>
                </div>

                <div class="score-left mx-1 mb-2">
                  <h4
                    class="percentage-change mb-0 mt-0"
                    :class="percents.over_prior.product < 0 ? 'red':'green'"
                  >
                    <fai v-if="percents.over_prior.product < 0" 
                         :icon="['fas', 'long-arrow-down']"
                         class='red'/>
                    <fai v-if="percents.over_prior.product > 0" 
                         :icon="['fas', 'long-arrow-up']"
                         class='green'/>
                    {{percents.over_prior.product}}%
                  </h4>
                  <span class="small" :class="percents.over_prior.product < 0 ? 'red':'green'"
                    >{{ percents.over_prior.product | directionAText }}</span
                  >
                </div>
              </div>
            </div>

            <!-- Product Score Stats -->
            <p class="text-muted text-center mt-1">
              your current score is
              <span :class="percents.over_industry.product < 0 ? 'red':'green'"
                ><b>{{percents.over_industry.product}}% {{ percents.over_industry.product | directionBText }}</b></span
              >
              the current product score industry average of
              <b>{{selectedStore.industry_average_product.toFixed(2)}}</b>.
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="row">
      <div class="col-sm-12">
        <section>
          <div class="stores-scores-table-wrapper">
            <div class="box box-wrapper d-flex justify-center">
              <sb-loading-icon v-if="showLoading"/>
              <table v-else class="table">
                <thead class="">
                  <tr>
                    <th />
                    <th />
                    <th colspan=2>
                      <div class="d-flex justify-center">
                        nps scores
                      </div>
                    </th>
                    <th colspan=2>
                      <div class="d-flex justify-center">
                        cs scores
                      </div>
                    </th>
                    <th colspan=2>
                      <div class="d-flex justify-center">
                        product scores
                      </div>
                    </th>
                  </tr>
                  <tr>
                    <th v-for="(column, index) in columnDefs" :key="index" :class="column.class">
                      <div 
                        class="d-flex"
                        :class="column.class"
                        v-on:mousedown="handleCallingDataSort(column.field)"
                        >
                        <div :ref="`${column.field}.field`" class="d-flex mr-1 text-center">
                          {{ column.header }}
                        </div>
                        <div
                          :ref="`${column.field}.order`"
                          class="d-flex mx-2 text-center sort-order-wrapper"
                          v-if="column.field == dataConfig.params.sort_field"
                        >
                          <div class="asc btn-up" v-if="dataConfig.params.sort == 'ASC'">
                            <fai :icon="['far', 'chevron-up']" class="ml-1"/>
                          </div>
                          <div class="desc btn-down" v-if="dataConfig.params.sort == 'DESC'">
                            <fai :icon="['far', 'chevron-down']" class="ml-1"/>
                          </div>
                        </div>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-if="currentScores.length != 0"
                    v-for="(row, index) in currentScores.data"
                    :key="index"
                    class="on-hover"
                    :class="{'bg-info': row.store_id == selectedStore.store_id}"
                    :ref="row.store_id"
                    v-on:mouseover="onStoreHover(row, 'enter')"
                    v-on:mouseleave="onStoreHover(row, 'leave')"
                    v-on:mousedown="setSelected(row)"
                  >
                    <td class="text-center">
                      <fai 
                        :icon="['fas', 'check']"
                        v-if="selectedStore.store_id == row.store_id" />
                    </td>
                    <td class="text-left">
                      {{ row.store.name.toLowerCase() }}
                    </td>
                    <td class="text-center">
                      {{ row.nps_score_current.toFixed(2) }}
                    </td>
                    <td class="text-center">
                      {{ row.nps_score_prior.toFixed(2) }}
                    </td>
                    <td class="text-center">
                      {{ row.crs_score_current.toFixed(2) }}
                    </td>
                    <td class="text-center">
                      {{ row.crs_score_prior.toFixed(2) }}
                    </td>
                    <td class="text-center">
                      {{ row.product_score_current.toFixed(2) }}
                    </td>
                    <td class="text-center">
                      {{ row.product_score_prior.toFixed(2) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Pagination -->
            <div class="footer-pager">
              <div class="d-flex justify-space-between align-center">
                <div class="d-flex justify-center align-center mr-1">
                  <button
                    class="btn prev-btn btn-primary btn-small"
                    :disabled="currentScores.current_page == 1"
                    :class="{'disabled': currentScores.current_page == 1}"
                    @click="handleGetPage('prev')"
                  >
                    <fai :icon="['far', 'chevron-left']" class="mr-1"/>prev
                  </button>
                </div>
                <div class="d-flex justify-center align-center mx-3">
                  showing {{ paginationText }} of {{currentScores.total}} results
                </div>
                <div class="d-flex justify-center align-center ml-1">
                  <button
                    class="btn next-btn btn-primary btn-small"
                    :disabled="currentScores.current_page == currentScores.last_page"
                    :class="{'disabled': currentScores.current_page == currentScores.last_page}"
                    @click="handleGetPage('next')"
                  >
                    next<fai :icon="['far', 'chevron-right']" class="ml-1"/>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </section>
</template> 

<script>
import { feedbackAPI } from "../../../../services/api/feedbackAPI"
import LoadingIcon from '../../../shared/LoadingIcon';
import moment from 'moment';

export default {
  name: "TypeScoringContainer",
  components: {
    LoadingIcon
  },
  data() {
    return {
      columnDefs: [
        {
          header: "selected",
          field: false,
          class: "justify-center ml-1"
        },
        {
          header: "store name",
          field: "store.name",
          class: ""
        },
        {
          header: "current",
          field: "nps_score_current",
          class: "justify-center ml-1 on-hover"
        },
        {
          header: "prior",
          field: "nps_score_prior",
          class: "justify-center ml-1 on-hover"
        },
        {
          header: "current",
          field: "crs_score_current",
          class: "justify-center ml-1 on-hover"
        },
        {
          header: "prior",
          field: "crs_score_prior",
          class: "justify-center ml-1 on-hover"
        },
        {
          header: "current",
          field: "product_score_current",
          class: "justify-center ml-1 on-hover"
        },
        {
          header: "prior",
          field: "product_score_prior",
          class: "justify-center ml-1 on-hover"
        }
      ],
      dataConfig: {
        params: {
          page: 1,
          sort_field: 'nps_score_current',
          sort: 'DESC'
        }
      },
      selectedStore: [],
      percents: {
        over_prior: {
          nps: 0,
          crs: 0,
          product: 0
        },
        over_industry: {
          nps: 0,
          crs: 0,
          product: 0
        }
      },
      currentScores: [],
      showLoading: true
    };
  },
  async created() {
    this.currentScores = await feedbackAPI.GETCurrentScores(this.dataConfig)
    this.selectedStore = this.currentScores.data[0]
    this.$root.$on("setStore", () => {
      this.refresh()
    });
    this.showLoading = false

  },
  computed: {
    paginationText() {
      const from = this.currentScores.from
      const to = this.currentScores.to

      if(from && to) return `${from}-${to}`
      return 0
    }
  },
  methods: {
    async refresh() {
      this.showLoading = true
      this.currentScores = await feedbackAPI.GETCurrentScores(this.dataConfig)
      this.selectedStore = this.currentScores.data[0]
      this.showLoading = false
    },
    formatDate(date) {
      return moment(date, "YYYY-MM-DD hh:mm:ss").format("ddd, MMM Do")
    },
    percentageDifference(val1, val2) {
      //difference
      const diff = Number(val1) - Number(val2);

      const avg = Number(Number(val1) + Number(val2)) /2

      //percentage change
      const perc = Number(diff / avg) * 100;

      //format as 2 digit percentage-change
      const finalPercentage = Number(perc.toFixed(2));

      return finalPercentage;
    },
    async handleCallingDataSort(field) {
      const csf = this.dataConfig.params.sort_field
      const cso = this.dataConfig.params.sort

      if(!field || field == 'store.name') return

      //we pass the field but we need the order
      if (csf == field) {
        if (cso == "ASC") this.dataConfig.params.sort = 'DESC';
        if (cso == "DESC") this.dataConfig.params.sort = 'ASC';
      } else {
        this.dataConfig.params.sort_field = field;
      }

      this.dataConfig.params.page = 1
      this.currentScores = await feedbackAPI.GETCurrentScores(this.dataConfig)

    },
    async handleGetPage(direction) {
      const { currentScores } = this;

      if (direction == 'prev') {
        if (currentScores.current_page == 1) return;

        this.dataConfig.params.page = currentScores.current_page - 1;
      } else if (direction == 'next') {
        if (currentScores.current_page == currentScores.last_page) return;

        this.dataConfig.params.page = currentScores.current_page + 1;
      }

      this.currentScores = await feedbackAPI.GETCurrentScores(this.dataConfig)
    },
    onStoreHover(row, action) {
      const ele = this.$refs[row.store_id];

      if(action == 'enter') {
        ele[0].classList.add("bg-info");
      } else if (action == 'leave' && row.store_id !== this.selectedStore.store_id) {
        ele[0].classList.remove("bg-info");
      }
    },
    setSelected(row) {
      this.selectedStore = row
    }
  },
  watch: {
    selectedStore: function(val) {
      let { percentageDifference } = this
      this.percents = {
        over_prior: {
          nps: this.percentageDifference(
                 val.nps_score_current, 
                 val.nps_score_prior).toFixed(2),
          crs: this.percentageDifference(
                 val.crs_score_current, 
                 val.crs_score_prior).toFixed(2),
          product: this.percentageDifference(
                     val.product_score_current, 
                     val.product_score_prior).toFixed(2)
        },
        over_industry: {
          nps: this.percentageDifference(
                 val.nps_score_current, 
                 val.industry_average_nps).toFixed(2),
          crs: this.percentageDifference(
                 val.crs_score_current, 
                 val.industry_average_crs).toFixed(2),
          product: this.percentageDifference(
                     val.product_score_current, 
                     val.industry_average_product).toFixed(2)
        }
      }
    }
  },
  filters: {
    directionAText: (value) => {
      if (value > 0) return "increase";
      if (value < 0) return "decrease";
    },
    directionBText: (value) => {
      if (value > 0) return "above";
      if (value < 0) return "below";
    }
  }
};
</script>